import { Avatar } from '@material-ui/core'
import cx from 'clsx'

import { QAHeader } from './QAHeader'

interface QuestionProps {
  q: string
  info: boolean
}

export function Question({ q, info }: QuestionProps) {
  return (
    <QAHeader
      title={q}
      titleClass="faq-answer-title"
      avatar={
        <Avatar
          aria-label="Question"
          className={cx('faq-answer-q', {
            'faq-answer-q--info': info,
          })}
        >
          {info ? '!' : 'Q'}
        </Avatar>
      }
    />
  )
}
